<template>
  <div class="topBack">
    <img :src="back" alt="" @click="goBack">
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
import back from '@/assets/images/common/back.svg'

export default {
  name: 'TopBack',
  props: ['title', 'handelBack'],
  data () {
    return {
      back
    }
  },
  methods: {
    goBack () {
      if (this.handelBack) {
        this.handelBack()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.topBack {
  position: fixed;
  top: 0;
  width: 100vw;
  height: calc(60vw / 3.6);
  background: var(--container);
  z-index: 99999;

  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: calc(24vw / 3.6);
    width: calc(12vw / 3.6);
    height: auto;
  }

  .title {
    position: relative;
    color: var(--blackFont);
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-weight: 600;
    font-size: calc(17vw / 3.6);
    line-height: calc(22vw / 3.6);
    letter-spacing: -0.01em;
    width: max-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopBack/index.vue